<template>
  <div class="SpecialNoteVue">
    <!-- {{ address_type }}sdaf{{ userChiose }} -->
    <div class="modelTitleAndequivalentSurcharge">
      <div class="moTitle">
        {{ $fanyi("选择或添加送货地址") }}
      </div>
      <!-- 这里说不展示并且默认选否 -->
      <div class="chioseBox" v-if="false">
        <span
          :class="{
            readOnly: !cantEdit,
          }"
          @click="$parent.doesCompanyPayTax = !$parent.doesCompanyPayTax"
        >
          {{ $fanyi("等值附加费") }}(5,2%)
        </span>
        <el-popover placement="top-start" trigger="click">
          <div class="optionHints">
            <div class="con">
              <h1>{{ $fanyi("等值附加费") }}</h1>
              <p>
                {{
                  $fanyi(
                    "如果你是在特别等同附加费制度下纳税的，请在购买发票上的方框内打勾。"
                  )
                }}
              </p>
            </div>
          </div>
          <img
            slot="reference"
            :src="require('@/assets/icon/info_fill.svg')"
            alt=""
          />
        </el-popover>
        <el-button
          :class="{
            active: $parent.doesCompanyPayTax == false,
            readOnly: !cantEdit,
            error: equivalentSurchargeError,
          }"
          @click="chioseequivalentSurcharge(false)"
        >
          {{ $fanyi("否") }}
        </el-button>
        <el-button
          :class="{
            active: $parent.doesCompanyPayTax == true,
            readOnly: !cantEdit,
            error: equivalentSurchargeError,
          }"
          @click="chioseequivalentSurcharge(true)"
        >
          {{ $fanyi("是") }}
        </el-button>
      </div>
    </div>
    <div class="SpecialNoteVueCon">
      <div class="addressSelection">
        <!-- 左侧选择框 -->
        <div class="addressChioseList" :class="{ optError: addressError }">
          <!-- 我的地址 -->
          <el-collapse accordion v-model="openelCollapse">
            <el-collapse-item>
              <template slot="title">
                <div class="addressChioseOpt">
                  <div class="imgBox">
                    <img
                      style="width: 20px;height: 25px;"
                      :src="require('@/assets/icon/xuanfoi.png')"
                      alt=""
                    />
                  </div>
                  <span>
                    {{ $fanyi("我的地址") }}
                  </span>
                </div>
              </template>
              <div class="customAddressListBox">
                <div
                  class="customAddressOptBox"
                  :class="{ readOnly: !cantEdit, activeOpt: item.checked }"
                  v-for="(item, index) in userAddressList"
                  :key="index"
                  @click="chioseThis(item, index)"
                >
                  <div class="customNameBox">
                    <input
                      type="checkbox"
                      class="readOnly"
                      :checked="item.checked"
                    />
                    <span class="customNameFont">
                      {{ $fanyi("地址") }} {{ index + 1 }}
                    </span>
                  </div>
                  <div class="customConBox">
                    {{ item.address }},{{ item.city }} {{ item.zip_code }},
                    {{ item.country }}
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <!-- 发货至亚马逊FBA仓库 -->
          <div
            :class="{ active: address_type == '4', readOnly: !cantEdit }"
            class="addressChioseOpt"
            @click="chiosePreset('4')"
          >
            <div class="imgBox">
              <img
                style="width: 34px;height: 34px;"
                :src="require('@/assets/icon/Capa2048.png')"
                alt=""
              />
            </div>
            <span>
              {{ $fanyi("发货至亚马逊FBA仓库") }}
            </span>
          </div>
          <!-- 订单模式 -->
          <div
            class="orderModeBox"
            :class="{ 'orderModeBox--readonly': !cantEdit }"
          >
            <!-- 临时保存/修改中：可展开选择 -->
            <template v-if="cantEdit">
              <div class="orderModeHeader">
                <div class="imgBox orderModeIconBox">
                  <img :src="require('@/assets/icon/CheckTwin.svg')" alt="" />
                </div>
                <!-- 订单模式 -->
                <span>{{ $fanyi("订单模式") }}</span>
              </div>
              <div class="orderModeOptions">
                <div
                  class="orderModeOpt"
                  :class="{
                    readOnly: !cantEdit,
                    activeOpt: order_default_mode === item.value,
                  }"
                  v-for="item in orderModeList"
                  :key="item.value"
                  @click="chioseOrderMode(item.value)"
                >
                  <div
                    class="modeCheckbox"
                    :class="{ checked: order_default_mode === item.value }"
                  ></div>
                  <div class="modeLabelRow">
                    <!-- DAP模式自税 / 普通订单 -->
                    <span class="modeLabel">{{ $fanyi(item.label) }}</span>
                    <el-popover
                      placement="top-start"
                      width="320"
                      trigger="click"
                      popper-class="order-mode-tip-popover"
                    >
                      <div class="orderModeTipContent">
                        {{ $fanyi(item.tipKey) }}
                      </div>
                      <div slot="reference" class="orderModeTip" @click.stop>
                        <img
                          :src="require('@/assets/icon/QuestMark.svg')"
                          alt=""
                        />
                      </div>
                    </el-popover>
                  </div>
                </div>
              </div>
            </template>
            <!-- 其他状态：只读展示已选模式 -->
            <template v-else>
              <div class="orderModeHeader orderModeHeader--readonly">
                <div class="orderModeHeaderLeft">
                  <div class="imgBox orderModeIconBox">
                    <img :src="require('@/assets/icon/CheckTwin.svg')" alt="" />
                  </div>
                  <!-- 订单模式 -->
                  <span>{{ $fanyi("订单模式") }}</span>
                </div>
                <div class="orderModeReadonlyValue">
                  <!-- DAP模式自税 / 普通订单 -->
                  <span>{{ $fanyi(activeOrderModeLabel) }}</span>
                  <el-popover
                    placement="top-start"
                    width="320"
                    trigger="click"
                    popper-class="order-mode-tip-popover"
                  >
                    <div class="orderModeTipContent">
                      {{ $fanyi(activeOrderModeTipKey) }}
                    </div>
                    <div slot="reference" class="orderModeTip" @click.stop>
                      <img
                        :src="require('@/assets/icon/QuestMark.svg')"
                        alt=""
                      />
                    </div>
                  </el-popover>
                </div>
              </div>
            </template>
          </div>
        </div>
        <!-- 右侧显示框 -->
        <div class="showChioseBox">
          <div
            class="showChioseBoxCon customAddress"
            v-if="address_type == '1'"
            key="io0"
          >
            <img :src="require('@/assets/icon/customAddress.png')" alt="" />
            <h2>
              {{ $fanyi("地址") }}
              {{
                userAddressList.findIndex((io) => io.id == userChiose.id) + 1 ||
                  ""
              }}
            </h2>
            <div class="conFont">
              {{ userChiose.address }},{{ userChiose.city }}
              {{ userChiose.zip_code }},
              {{ userChiose.country }}
            </div>
          </div>
          <div
            class="showChioseBoxCon chioseRakumart"
            v-else-if="address_type == '2'"
            key="io1"
          >
            <img
              style="width: 182px;height: 42px;"
              :src="require('@/assets/icon/ffsfas.png')"
              alt=""
            />
            <h2>{{ $fanyi("在Rakumart西班牙仓库取货") }}</h2>
            <div class="conFont">
              {{
                $fanyi(
                  "请通过rakuchat或WhatsApp告知您要发货至的亚马逊仓库地址。"
                )
              }}
            </div>
          </div>
          <div
            class="showChioseBoxCon chioseRakumart"
            v-else-if="address_type == '3'"
            key="io2"
          >
            <img
              style="width: 88px;height: 88px;"
              :src="require('@/assets/icon/BeepingFullfilment.png')"
              alt=""
            />
            <h2>Beeping Fulfillment</h2>
            <div class="conFont" style="width: 220px;">
              {{ $fanyi("Beeping仓库地址") }}
            </div>
          </div>
          <div
            class="showChioseBoxCon chioseRakumart"
            v-else-if="address_type == '4'"
            key="io3"
          >
            <img
              style="width: 144px;height: 81px;"
              :src="require('@/assets/icon/amazon.png')"
              alt=""
            />
            <h2>{{ $fanyi("发货至亚马逊FBA仓库") }}</h2>
            <div class="conFont">
              {{
                $fanyi(
                  "请通过rakuchat或WhatsApp告知您要发货至的亚马逊仓库地址。"
                )
              }}
            </div>
          </div>
          <div
            class="showChioseBoxCon chioseAmazon"
            :class="{ readOnly: !cantEdit }"
            v-else
            key="io4"
            @click="openAddBox()"
          >
            <img
              style="width: 40px;height: 40px;"
              :src="require('@/assets/icon/addAddress.png')"
              alt=""
            />
            <div class="conFont">
              {{ $fanyi("选择或添加新地址") }}
            </div>
          </div>
        </div>
      </div>
      <div class="rightChioseAnfPriceBox">
        <div class="priceBox">
          <!-- 订单费用合计(中国) -->
          <h1>
            {{ $fanyi("订单费用合计(中国)") }}
            <span class="price">
              {{
                $fun.EURNumSegmentation(
                  $fun.ceil(
                    ($parent.orderPriceGroup.sum_price || 0) *
                      $parent.datas.exchange_rate
                  )
                )
              }}€
            </span>
          </h1>
          <div class="priceOrder">
            <!-- 费用明细 -->
            <h2>{{ $fanyi("费用明细") }}</h2>
            <p>
              {{ $fanyi("产品价值")
              }}<span class="otherPrice">
                {{
                  $fun.EURNumSegmentation(
                    $fun.ceil(
                      $parent.orderPriceGroup.goods_price *
                        $parent.datas.exchange_rate
                    )
                  )
                }}€({{
                  $fun.RMBNumSegmentation($parent.orderPriceGroup.goods_price)
                }}￥)</span
              >
            </p>
            <p>
              <span
                >{{ $fanyi("佣金") }}({{
                  Math.round(
                    Number($parent.orderPriceGroup.service_rate) * 100
                  )
                }}%)</span
              ><span class="otherPrice">
                {{
                  $fun.EURNumSegmentation(
                    $fun.ceil(
                      $parent.orderPriceGroup.service_rate_price *
                        $parent.datas.exchange_rate
                    )
                  )
                }}€({{
                  $fun.RMBNumSegmentation(
                    $parent.orderPriceGroup.service_rate_price
                  )
                }}￥)
              </span>
            </p>
            <p>
              {{ $fanyi("附加服务")
              }}<span class="otherPrice">
                {{
                  $fun.EURNumSegmentation(
                    $fun.ceil(
                      $parent.orderPriceGroup.option_price *
                        $parent.datas.exchange_rate
                    )
                  )
                }}€({{
                  $fun.RMBNumSegmentation($parent.orderPriceGroup.option_price)
                }}￥)
              </span>
            </p>
            <p v-if="$parent.orderPriceGroup.alibaba_service_fees">
              <span class="dip"
                >{{ $fanyi("国际阿里巴巴支付手续费（3%）") }}
                <span class="international-alibaba-payment-info-tip">
                  <el-popover
                    placement="top-end"
                    width="272"
                    trigger="click"
                    popper-class="international-alibaba-payment-info-tip-popover"
                  >
                    <div class="international-alibaba-payment-info-tip-content">
                      {{
                        $fanyi(
                          "手续费固定为商品金额的3%，该手续费由Alibaba进行收取，RAKUMART代收后支付至Alibaba。"
                        )
                      }}
                    </div>
                    <div slot="reference" class="dip">
                      <img
                        :src="
                          require('@/assets/icon/international-alibaba-payment-info-tip.svg')
                        "
                        alt=""
                      />
                    </div>
                  </el-popover>
                </span>
              </span>

              <span class="otherPrice">
                {{
                  $fun.EURNumSegmentation(
                    $parent.orderPriceGroup.alibaba_service_fees_eu
                  )
                }}€({{
                  $fun.RMBNumSegmentation(
                    $parent.orderPriceGroup.alibaba_service_fees
                  )
                }}￥)
              </span>
            </p>
            <p>
              {{ $fanyi("其他费用")
              }}<span class="otherPrice">
                {{
                  $fun.EURNumSegmentation(
                    $fun.ceil(
                      $parent.orderPriceGroup.others_price *
                        $parent.datas.exchange_rate
                    )
                  )
                }}€({{
                  $fun.RMBNumSegmentation($parent.orderPriceGroup.others_price)
                }}￥)
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="$fanyi('添加收货地址')"
      width="803px"
      :visible.sync="show"
      ref="odialog"
      destroy-on-close
    >
      <orderjinkoushangForm ref="DizhiForm" />
    </el-dialog>
  </div>
</template>
<script>
import orderjinkoushangForm from "./orderdizhiForm.vue";
export default {
  data() {
    return {
      address_type: null, //1-客户收件地址 2-rakumart仓库 3-deeping仓库 4-亚马逊仓库
      userChiose: {}, //用户选择的地址
      userAddressList: [], //用户收货人地址列表
      show: false,
      openelCollapse: "", //控制el-collapse
      equivalentSurchargeError: false, //增值税错误样式
      addressError: false, // 地址选择错误样式控制
      // 订单清关模式：1-DAP模式自税 2-普通订单(RAKUMART代清关)，null 表示未选择
      order_default_mode: null,
      // 是否已由 orderDetail 接口回填，避免被 userInfo 默认值覆盖
      orderModeFromApi: false,
      orderModeList: [
        {
          value: 1,
          label: "DAP模式自税",
          tipKey:
            "DAP（客户EORI清关模式）：RAKUMART全程负责运输至指定目的地。清关阶段将调用您的EORI号，并同步提供欧盟标准SAD/DUA清关凭证。清关产生的关税、VAT等相关税费需由客户自行依法缴纳。",
        },
        {
          value: 2,
          label: "普通订单",
          tipKey:
            "标准订单模式（RAKUMART代清关）：采用RAKUMART税号进行清关，实现“中国仓到最终目的地”的一站式闭环服务。我们将为您提供包含RAKUMART税号的合规商业发票，确保货物清关及后续税务合规。",
        },
      ],
    };
  },
  components: { orderjinkoushangForm },
  computed: {
    orderStatus() {
      return this.$parent.orderStatus;
    },
    cantEdit() {
      return ["temporary", "editing"].includes(this.$parent.orderStatus);
    },
    // 只读态展示当前订单模式文案
    activeOrderModeItem() {
      return (
        this.orderModeList.find(
          (item) => item.value === this.order_default_mode
        ) || this.orderModeList[0]
      );
    },
    activeOrderModeLabel() {
      return this.activeOrderModeItem.label;
    },
    activeOrderModeTipKey() {
      return this.activeOrderModeItem.tipKey;
    },
  },
  created() {
    this.getUserAddress();
  },
  watch: {
    // 仅购物车预览新建订单（有 id、无 order_sn）时用 userInfo 默认订单模式
    orderStatus(val) {
      if (val !== "temporary" || this.orderModeFromApi) return;
      if (this.order_default_mode === 1 || this.order_default_mode === 2) return;
      const route = this.$route || (this.$parent && this.$parent.$route);
      if (route && route.query.order_sn) return;
      if (route && route.query.id) {
        this.applyUserInfoOrderDefaultMode();
      }
    },
  },
  methods: {
    // 解析接口 order_default_mode：1/2 有效，其余为 null
    parseOrderDefaultMode(value) {
      const mode = Number(value);
      return mode === 1 || mode === 2 ? mode : null;
    },
    // 订单详情返回前先写入模式，避免 orderStatus watch 抢先套用 userInfo
    prefillOrderModeFromApi(value) {
      const mode = this.parseOrderDefaultMode(value);
      if (mode == null) return;
      this.order_default_mode = mode;
      this.orderModeFromApi = true;
    },
    // 临时保存时从 userInfo 读取订单模式默认值（已有接口值时不覆盖）
    applyUserInfoOrderDefaultMode() {
      if (this.$parent.orderStatus !== "temporary") return;
      if (this.orderModeFromApi) return;
      if (this.order_default_mode === 1 || this.order_default_mode === 2) return;
      const userMode = Number(
        (this.$store.state.userInfo || {}).order_default_mode
      );
      if (userMode === 1 || userMode === 2) {
        this.order_default_mode = userMode;
      }
    },
    // 选择是否代收等值附件费
    chioseequivalentSurcharge(value) {
      this.$parent.doesCompanyPayTax = value;
      this.equivalentSurchargeError = false;
    },
    // 打开添加地址的弹窗
    openAddBox(data) {
      this.show = true;
      this.$nextTick(() => {
        if (data) {
          this.$refs.DizhiForm.open(data);
        }
      });
    },
    // 获取用户地址列表
    getUserAddress() {
      this.$api.useraddressList().then((res) => {
        if (res.code != 0) return;
        this.userAddressList = res.data.consignee;
        // 如果是新添加的用户地址,由于数据是从表单组件上传下来的所以没有id,需要在这里查找并赋予
        if (this.userChiose.address && !this.userChiose.id) {
          let finddata = res.data.consignee.find(
            (kll) => kll.address == this.userChiose.address
          );
          if (finddata) {
            this.userChiose.id = finddata.id;
          }
        }
        this.syncAddressCheckedState();
      });
    },
    // 同步已选地址勾选状态（不改动订单模式）
    syncAddressCheckedState() {
      if (
        this.userAddressList.length &&
        this.userChiose.id &&
        this.address_type == 1
      ) {
        const chioseAddressData = this.userAddressList.find(
          (adIt) => adIt.id == this.userChiose.id
        );
        if (chioseAddressData) {
          chioseAddressData.checked = true;
        }
      }
      this.$forceUpdate();
    },
    // 选择订单清关模式
    chioseOrderMode(value) {
      if (!this.cantEdit) return;
      this.order_default_mode = value;
      this.orderModeFromApi = false;
    },
    // 选择用户自定义地址
    chioseThis(item, index) {
      this.addressError = false;
      if (item.checked) {
        item.checked = false;
        this.userChiose = {};
        this.address_type = null;
        this.userChiose = {};
      } else {
        this.userAddressList.forEach((element) => {
          element.checked = false;
        });
        item.checked = true;
        this.userChiose = item.id;
        this.userChiose = item;
        this.address_type = 1;
        this.openelCollapse = "";
      }
      this.$forceUpdate();
    },
    // 选择预设地址
    chiosePreset(type) {
      this.addressError = false;
      this.address_type = type;
      this.userAddressList.forEach((element) => {
        element.checked = false;
      });
      this.userChiose = {
        type: type,
      };
    },
    // 在接口返回数据的时候设置页面数据
    setHave(odata) {
      if (odata) {
        this.address_type = odata.address_type;
        this.userChiose = odata.userChiose;
        const apiMode = this.parseOrderDefaultMode(odata.order_default_mode);
        const isTemporary = this.$parent.orderStatus === "temporary";
        if (apiMode != null) {
          this.order_default_mode = apiMode;
          this.orderModeFromApi = true;
        } else if (isTemporary && !this.orderModeFromApi) {
          // 仅临时保存且接口未返回有效模式时，回退 userInfo
          this.applyUserInfoOrderDefaultMode();
        } else if (!isTemporary) {
          // 非临时保存：接口未返回或为 0 时不取 userInfo
          this.order_default_mode = null;
          this.orderModeFromApi = false;
        }
      }
      this.syncAddressCheckedState();
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../../../../../css/mixin.scss";

.SpecialNoteVue {
  // align-items: flex-start;
  min-height: 373px;
  width: 1400px;
  margin: 0 auto;
  .modelTitleAndequivalentSurcharge {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px 3px 15px 15px;
    min-height: 43px;
    .moTitle {
      font-size: 16px;
      font-weight: bold;
      line-height: 9px;
    }
    .chioseBox {
      .readOnly {
        pointer-events: none;
      }
      span {
        cursor: pointer;
        font-size: 16px;
        margin-right: 6px;
      }
      img {
        width: 17px;
        height: 17px;
        cursor: pointer;
        transform: translateY(3px);
        margin-right: 17px;
      }
      .el-button {
        width: 74px;
        border-radius: 16px;
        border: 2px solid #e8e8e8;
        height: 43px;
      }
      .el-button.active {
        background: #009246;
        border: 2px solid #009246;
        color: white;
      }
      .el-button.error {
        border: 2px solid #ffccd2;
        animation: doudong 0.7s;
      }
    }
  }
  .SpecialNoteVueCon {
    display: flex;
  }
  .addressSelection {
    width: 910px;
    display: flex;
    .addressChioseList {
      width: 436px;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      margin-right: 20px;
      .addressChioseOpt {
        width: 436px;
        height: 69px;
        background: #ffffff;
        border: 2px solid #dbd7d6;
        border-radius: 16px;
        margin-bottom: 18px;
        display: flex;
        align-items: center;
        padding: 0 25px;
        cursor: pointer;
        &:last-child {
          margin-bottom: 0;
        }
        .imgBox {
          margin-right: 12px;
          @extend .dip;
        }
      }
      .addressChioseOpt.active {
        border: 2px solid #009246;
      }
      .customAddressListBox {
        padding: 8px 0 0 25px;
        margin-right: 34px;
        height: 238px;
        overflow: auto;
        &::-webkit-scrollbar {
          width: 9px;
          height: 1px;
        }

        &::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 5px;
          -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);
          background: #535353;
        }

        &::-webkit-scrollbar-track {
          /*滚动条里面轨道*/
          background: #ececec;
          -webkit-box-shadow: inset005pxrgba(0, 0, 0, 0.2);
          border-radius: 5px;
        }
        .customAddressOptBox {
          margin-right: 25px;
          height: 69px;
          border: 2px solid #dbd7d6;
          border-radius: 2px;
          padding: 14px 12px;
          margin-bottom: 8px;
          cursor: pointer;
          .customNameBox {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            input {
              border: 2px solid #009246;
              margin-right: 9px;
            }
            input[type="checkbox"]:checked {
              background-color: #009246;
            }
            .customNameFont {
              font-size: 14px;
              line-height: 1;
              color: #2f2f2f;
            }
          }
          .customConBox {
            line-height: 1;
            height: 13px;
            font-size: 12px;
            padding-left: 26px;
            color: #8a8a8a;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        .activeOpt {
          border-color: #009246;
        }
      }
      .el-collapse {
        margin-bottom: 18px;
        height: 69px;
        position: relative;
        z-index: 1;
      }
      .orderModeBox {
        width: 436px;
        background: #ffffff;
        border: 2px solid #eaecf0;
        border-radius: 16px;
        padding: 20px 25px 25px;
        margin-bottom: 18px;
        .orderModeHeader {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 20px;
          .orderModeIconBox {
            width: 34px;
            height: 34px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
            img {
              width: 34px;
              height: 34px;
              display: block;
              object-fit: contain;
            }
          }
          span {
            font-size: 16px;
            font-weight: 600;
            line-height: 22px;
            color: #344554;
          }
        }
        .orderModeHeader--readonly {
          width: 100%;
          margin-bottom: 0;
          justify-content: space-between;
          align-items: center;
          gap: 12px;
          .orderModeHeaderLeft {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-shrink: 0;
          }
        }
        .orderModeReadonlyValue {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 4px;
          flex: 1;
          min-width: 0;
          text-align: right;
          span {
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            color: #000000;
            word-break: break-word;
          }
        }
        .orderModeOptions {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }
        .orderModeOpt {
          width: 100%;
          flex: none;
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          &.readOnly {
            pointer-events: none;
          }
          .modeCheckbox {
            width: 22px;
            height: 22px;
            border-radius: 4px;
            border: 1px solid #eaecf0;
            background: #ffffff;
            flex-shrink: 0;
            position: relative;
            align-self: center;
            &.checked {
              background: #009246;
              border-color: #009246;
              &::after {
                content: "";
                position: absolute;
                left: 7px;
                top: 4px;
                width: 5px;
                height: 9px;
                border: solid #ffffff;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
              }
            }
          }
          .modeLabelRow {
            display: flex;
            align-items: center;
            flex: 1;
            min-width: 0;
            min-height: 22px;
            gap: 4px;
            /deep/ .el-popover__reference-wrapper {
              display: inline-flex;
              align-items: center;
              align-self: center;
              line-height: 0;
            }
          }
          .modeLabel {
            flex: 1;
            min-width: 0;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            color: #000000;
            word-break: break-word;
          }
        }
        .orderModeTip {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          align-self: center;
          flex-shrink: 0;
          width: 16px;
          height: 16px;
          cursor: pointer;
          img {
            width: 16px;
            height: 16px;
            display: block;
            transform: translateY(2px);
          }
        }
      }
      .orderModeBox--readonly {
        padding: 20px 25px;
        min-height: 74px;
        height: auto;
        display: flex;
        align-items: center;
      }
      /deep/.el-collapse-item {
        border: 2px solid #dbd7d6;
        border-radius: 16px;
        .el-collapse-item__header {
          height: 69px;
          border-radius: 16px;
        }
        .el-collapse-item__arrow {
          // display: none;
          font-weight: bold;
          font-size: 19px;
          margin-right: 30px;
          transform: rotate(90deg);
          &.is-active {
            transform: rotate(-90deg);
          }
        }
        .addressChioseOpt {
          margin-bottom: 0;
          border: none;
          span {
            font-size: 16px;
          }
        }
      }
    }
    .optError {
      .addressChioseOpt,
      /deep/.el-collapse-item {
        animation: doudong 0.7s;
        border: 2px solid #ffccd2;
      }
    }
    .showChioseBox {
      width: 436px;
      background: #ffffff;
      border-radius: 16px;
      margin-right: 20px;
      .showChioseBoxCon {
        height: 100%;
        border: 2px solid #009246;
        border-radius: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        img {
          margin-bottom: 20px;
        }
        h2 {
          font-size: 16px;
          font-weight: 600;
          color: #2c2c2c;
          line-height: 1;
          margin-bottom: 15px;
        }
        .conFont {
          font-size: 16px;
          font-weight: 400;
          color: #7d7d7d;
          line-height: 21px;
          width: 240px;
          text-align: center;
        }
      }
      .customAddress {
        img {
          width: 26px;
          height: 31px;
        }
      }
      .chioseRakumart {
        img {
          width: 182px;
          height: 46px;
        }
        .conFont {
          width: 240px;
        }
      }
      .chioseAmazon {
        cursor: pointer;
        border: 2px dashed #dbd7d6;
        img {
          margin-bottom: 40px;
        }
        .conFont {
          line-height: 16px;
          line-height: 1.1;
          color: #2c2c2c;
          width: unset;
        }
      }
    }
  }
  .rightChioseAnfPriceBox {
    flex: 1;
    display: flex;
    flex-direction: column;
    .priceBox {
      padding: 31px 35px;
      background-color: white;
      border: 1px solid #e8e8e8;
      border-radius: 16px;
      h1 {
        font-size: 18px;
        font-weight: 600;
        color: #2f2f2f;
        line-height: 23px;
        height: 18px;
        margin-bottom: 23px;
        .price {
          color: #ffaf3e;
        }
      }
      .priceOrder {
        > * {
          padding: 15px 0;
        }
        h2 {
          font-size: 14px;
          line-height: 22.8px;
          font-weight: 500;
          padding: 0;
          margin-bottom: 10px;
        }
        p {
          font-weight: 400;
          display: flex;
          min-height: 50px;
          font-size: 14px;
          line-height: 14px;
          color: #868686;
          justify-content: space-between;
          align-items: center;
          border-bottom: solid 1px #e8e8e8;
          .otherPrice {
            color: #2f2f2f;
          }
        }
      }
    }
  }
}
// 这是弹出框的样式,需要写在外面
.optionHints {
  padding: 18px;
  .con {
    width: 270px;
    * {
      line-height: 22.84px;
      color: #2f2f2f;
    }
    h1 {
      margin-bottom: 25px;
      font-size: 18px;
      font-weight: 600;
    }
    p {
      text-align: left;
      font-size: 16px;
    }
  }
}

.orderModeTipContent {
  font-size: 14px;
  line-height: 22px;
  color: #2f2f2f;
  text-align: left;
}

/deep/.el-dialog {
  border-radius: 4px;
}
/deep/.el-dialog__header {
  padding: 35px 35px 0;
  border-bottom: none !important;
  font-size: 18px;
  font-weight: 600;
  color: #2f2f2f;
  line-height: 1;
  .el-icon-close {
    display: none;
  }
}

/deep/.el-dialog__body {
  padding: 30px 35px !important;
}
/deep/.el-dialog__footer {
  display: none;
}

.international-alibaba-payment-info-tip {
  margin-left: 0;
  display: inline-flex;
  align-items: center;
  vertical-align: middle;

  img {
    width: 20px;
    height: 20px;
    display: block;
    object-fit: contain;
  }
}

/deep/.el-collapse-item__wrap {
  border-radius: 0 0 16px 16px;
}
</style>
